import { render, staticRenderFns } from "./SysTypeCatManager.vue?vue&type=template&id=35d83c29&scoped=true&"
import script from "./SysTypeCatManager.vue?vue&type=script&lang=js&"
export * from "./SysTypeCatManager.vue?vue&type=script&lang=js&"
import style0 from "./SysTypeCatManager.vue?vue&type=style&index=0&id=35d83c29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d83c29",
  null
  
)

export default component.exports